// import React from "react";

// const Sofa = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <div className="text-sm text-gray-600 mb-4">
//         <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Koltuk Yıkama
//       </div>

//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">ANKARA KOLTUK YIKAMA HİZMETİ</h1>

//       <div className="space-y-6">
//         <p>
//           Abone Halı Yıkama olarak, koltuk yıkama hizmetlerimizle de Ankara'nın birçok ilçesine hijyenik ve profesyonel çözümler sunmaktayız. Uzman ekibimiz ve gelişmiş ekipmanlarımızla evinizde veya atölyemizde koltuk yıkama işlemlerini titizlikle gerçekleştiriyoruz.
//         </p>

//         <p>
//           Koltuklar, günlük kullanım nedeniyle en hızlı kirlenen ve mikrop barındıran eşyalardandır. Bu nedenle düzenli olarak temizlenmeleri, hem sağlığınız hem de estetik görünüm için büyük önem taşır. Profesyonel ekipmanlarımızla bu işlemi derinlemesine yapıyoruz.
//         </p>

//         <p>
//           Kullandığımız özel solüsyonlar sayesinde kumaşınıza zarar vermeden lekeleri çıkartıyor, koltuklarınızı ilk günkü görünümüne kavuşturuyoruz. Her koltuk tipine uygun farklı teknikler uygulayarak maksimum temizlik sağlıyoruz.
//         </p>

//         <p>
//           Evinizden çıkmadan hizmet alabileceğiniz bu sistemde, zamanınızı size bırakıyoruz. Alanında uzman personellerimiz yerinde hizmet vererek sizlere konforlu bir temizlik deneyimi sunuyor.
//         </p>

//         <p>
//           Ankara’da yerinde koltuk yıkama hizmetini bu kalitede ve bu uygun fiyatlarla sunan nadir firmalardan biriyiz. Kaliteden ödün vermeden, sağlığınızı ve konforunuzu önceliklendiriyoruz.
//         </p>

//         <p>
//           7/24 Whatsapp hattımız ve çağrı merkezimiz üzerinden randevu oluşturabilir, detaylı bilgi alabilirsiniz.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">🛋️ Profesyonel Koltuk Yıkama Hizmeti</h2>
//         <p>
//           Koltuklarınız zamanla bakteri, toz, leke ve kötü kokular barındırabilir. Abone Halı Yıkama, koltuklarınızı derinlemesine temizleyerek hijyenik hale getirir.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">💧 Koltuk Yıkama Sürecimiz</h2>
//         <ol className="list-decimal list-inside space-y-2">
//           <li>Ön kontrol ve kumaş analizi</li>
//           <li>Vakumla toz alma işlemi</li>
//           <li>Leke analizi ve özel müdahale</li>
//           <li>Özel makinelerle derinlemesine yıkama</li>
//           <li>Durulama ve nem alma işlemi</li>
//           <li>Kuruma süreci ve son kontrol</li>
//         </ol>

//         <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
//         <ul className="list-disc list-inside">
//           <li>Doğaya dost, insan sağlığına zarar vermeyen ürünler</li>
//           <li>Kumaş yapısına uygun özel temizleyiciler</li>
//           <li>Antibakteriyel ve anti-alerjik temizlik ürünleri</li>
//         </ul>

//         <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
//         <ul className="list-disc list-inside">
//           <li>Yerinde hizmet ile zaman kazandırıyoruz</li>
//           <li>Her koltuk kumaşına özel temizlik yöntemi</li>
//           <li>Modern ekipman ve deneyimli personel</li>
//           <li>Uygun fiyat politikası ve müşteri memnuniyeti garantisi</li>
//           <li>Randevulu ve dakik hizmet anlayışı</li>
//         </ul>

//         <p>
//           Tüm koltuk yıkama işlemlerimiz kayıt altındadır. Hijyenik ve profesyonel şekilde temizlik yaparak yaşam alanlarınıza ferahlık katıyoruz. Bize ulaşın, koltuklarınız yeniden hayat bulsun.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Sofa;
import React from "react";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const Sofa = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü için */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <div className="text-sm text-gray-600 mb-4">
            <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; 
            <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Koltuk Yıkama
          </div>

          <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
            ANKARA KOLTUK YIKAMA HİZMETİ
          </h1>

          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              Abone Halı Yıkama olarak, koltuk yıkama hizmetlerimizle de Ankara'nın birçok ilçesine hijyenik ve profesyonel çözümler sunmaktayız. Uzman ekibimiz ve gelişmiş ekipmanlarımızla evinizde veya atölyemizde koltuk yıkama işlemlerini titizlikle gerçekleştiriyoruz.
            </p>

            <p>
              Koltuklar, günlük kullanım nedeniyle en hızlı kirlenen ve mikrop barındıran eşyalardandır. Bu nedenle düzenli olarak temizlenmeleri, hem sağlığınız hem de estetik görünüm için büyük önem taşır. Profesyonel ekipmanlarımızla bu işlemi derinlemesine yapıyoruz.
            </p>

            <p>
              Kullandığımız özel solüsyonlar sayesinde kumaşınıza zarar vermeden lekeleri çıkartıyor, koltuklarınızı ilk günkü görünümüne kavuşturuyoruz. Her koltuk tipine uygun farklı teknikler uygulayarak maksimum temizlik sağlıyoruz.
            </p>

            <p>
              Evinizden çıkmadan hizmet alabileceğiniz bu sistemde, zamanınızı size bırakıyoruz. Alanında uzman personellerimiz yerinde hizmet vererek sizlere konforlu bir temizlik deneyimi sunuyor.
            </p>

            <p>
              Ankara’da yerinde koltuk yıkama hizmetini bu kalitede ve bu uygun fiyatlarla sunan nadir firmalardan biriyiz. Kaliteden ödün vermeden, sağlığınızı ve konforunuzu önceliklendiriyoruz.
            </p>

            <p>
              7/24 Whatsapp hattımız ve çağrı merkezimiz üzerinden randevu oluşturabilir, detaylı bilgi alabilirsiniz.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">🛋️ Profesyonel Koltuk Yıkama Hizmeti</h2>
            <p>
              Koltuklarınız zamanla bakteri, toz, leke ve kötü kokular barındırabilir. Abone Halı Yıkama, koltuklarınızı derinlemesine temizleyerek hijyenik hale getirir.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">💧 Koltuk Yıkama Sürecimiz</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Ön kontrol ve kumaş analizi</li>
              <li>Vakumla toz alma işlemi</li>
              <li>Leke analizi ve özel müdahale</li>
              <li>Özel makinelerle derinlemesine yıkama</li>
              <li>Durulama ve nem alma işlemi</li>
              <li>Kuruma süreci ve son kontrol</li>
            </ol>

            <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
            <ul className="list-disc list-inside">
              <li>Doğaya dost, insan sağlığına zarar vermeyen ürünler</li>
              <li>Kumaş yapısına uygun özel temizleyiciler</li>
              <li>Antibakteriyel ve anti-alerjik temizlik ürünleri</li>
            </ul>

            <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
            <ul className="list-disc list-inside">
              <li>Yerinde hizmet ile zaman kazandırıyoruz</li>
              <li>Her koltuk kumaşına özel temizlik yöntemi</li>
              <li>Modern ekipman ve deneyimli personel</li>
              <li>Uygun fiyat politikası ve müşteri memnuniyeti garantisi</li>
              <li>Randevulu ve dakik hizmet anlayışı</li>
            </ul>

            <p>
              Tüm koltuk yıkama işlemlerimiz kayıt altındadır. Hijyenik ve profesyonel şekilde temizlik yaparak yaşam alanlarınıza ferahlık katıyoruz. Bize ulaşın, koltuklarınız yeniden hayat bulsun.
            </p>
          </div>

          {/* Mobilde sola düşen sidebar */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>
    </>
  );
};

export default Sofa;
